import React, { CSSProperties } from "react"
import { GoogleMapLoader, GoogleMap, Marker } from "react-google-maps"
import * as utils from "../../helpers/utils"
interface IProps {
    locations: { lat: number, lng: number }[]
    // default {height: 100%}
    style?: CSSProperties
    // default 15
    zoom?: number
}

export default class MapLoader extends React.Component<IProps, {}>  {
    private _googleMapComponent
    componentDidMount() {
        const bounds = new google.maps.LatLngBounds()
        for (let i = 0; i < this.props.locations.length; i++) {
            bounds.extend(new google.maps.LatLng(utils.getNumberFromBigNumber(this.props.locations[i].lat), utils.getNumberFromBigNumber(this.props.locations[i].lng)))
        }
        setTimeout(() => {
            if (this._googleMapComponent) this._googleMapComponent.fitBounds(bounds)
        }, 0)
    }

    render() {
        return (
            <GoogleMapLoader
                containerElement={<div style={this.props.style ? this.props.style : { height: "100%" }} />}
                googleMapElement={
                    <GoogleMap ref={map => this._googleMapComponent = map} defaultZoom={this.props.zoom ? this.props.zoom : 15}>
                        {this.props.locations.map((location, i) =>
                            <Marker position={{ lat: utils.getNumberFromBigNumber(location.lat), lng: utils.getNumberFromBigNumber(location.lng) }} key={i} />
                        )}
                    </GoogleMap>
                }
            />
        )
    }
}
